import { render, staticRenderFns } from "./CustomToggle.vue?vue&type=template&id=5b815ce6&scoped=true&"
import script from "./CustomToggle.vue?vue&type=script&lang=ts&"
export * from "./CustomToggle.vue?vue&type=script&lang=ts&"
import style0 from "./CustomToggle.vue?vue&type=style&index=0&id=5b815ce6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b815ce6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSwitch } from 'vuetify/lib/components/VSwitch';
installComponents(component, {VSwitch})
